import { render, staticRenderFns } from "./ListsSelector.vue?vue&type=template&id=4cdd7424&"
import script from "./ListsSelector.vue?vue&type=script&lang=js&"
export * from "./ListsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports